import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-petrol relative overflow-hidden" data-id="element-91">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-petrol-light/10 via-petrol to-petrol pointer-events-none" data-id="element-92"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-93">
        <div className="text-center mb-16" data-id="element-94">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-white" data-id="element-95">
            El próximo lunes podés seguir improvisando...
            <br data-id="element-96" />
            <span className="text-gold-gradient" data-id="element-97">
              O podés entrar al aula con todo listo desde hoy.
            </span>
          </h2>

          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-night-card p-8 rounded-2xl border border-night-border" data-id="element-98">
            {['Sin más noches buscando cómo explicar la configuración electrónica o la estequiometría en palabras que tus alumnos entiendan', 'Sin más clases armadas de apuro con fotocopias de libros que no conectan con la realidad de tu región', 'Sin más alumnos desconectados que no entienden para qué sirve estudiar química', 'Sin más fines de semana perdidos construyendo prácticas de laboratorio que no podés hacer porque no tenés reactivos', 'Sin más silencios incómodos frente a preguntas que te ponen en aprietos'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-99">
                <span className="text-gold mt-1" data-id="element-100">▸</span>
                <span className="text-gray-300" data-id="element-101">{item}</span>
              </div>)}
          </div>

          <p className="text-xl text-white mb-2" data-id="element-102">
            El Mega Pack Química en el Aula no te convierte en mejor docente.
          </p>
          <p className="text-2xl font-bold text-gold mb-6" data-id="element-103">
            Vos ya sos un buen docente.
          </p>
          <p className="text-xl text-gray-300 mb-16" data-id="element-104">
            Lo que hace el Mega Pack es darte el tiempo y las herramientas para
            que eso se note en cada clase.
          </p>
        </div>

        <div className="bg-night border-2 border-gold/30 rounded-3xl p-8 md:p-12 shadow-[0_0_40px_rgba(212,175,55,0.1)]" data-id="element-105">
          <h3 className="text-2xl font-bold text-white mb-6 text-center border-b border-night-border pb-6" data-id="element-106">
            Todo lo que incluye:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-107">
            {['Tomo 1 — Arquitectura de la Materia', 'Tomo 2 — Enlace Químico y Nomenclatura', 'Tomo 3 — Reacciones Químicas y Estequiometría', 'Tomo 4 — Química Orgánica e Hidrocarburos', 'Tomo 5 — Laboratorio de Guerrilla', 'Tomo 6 — Química Ambiental y Sustentabilidad', 'Bono 1 — Paquete de Actividades Pro', 'Bono 2 — Banco de Evaluaciones y Rúbricas', 'Bono 3 — Manual de Bromatología y Análisis de Alimentos', 'Bono 4 — Guía de Gestión y Seguridad en Laboratorios Escolares', 'Garantía de 7 días sin preguntas', 'Pago en tu moneda local', 'Acceso inmediato', 'Formato PDF listo para usar'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-108">
                <Check size={18} className="text-success shrink-0" data-id="element-109" />
                <span className="text-sm text-gray-200" data-id="element-110">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-111">
            <div className="mb-8 p-6 bg-gold/5 rounded-xl border border-gold/20 italic text-gray-300 text-lg" data-id="element-112">
              "El mejor momento para tener este material era al inicio del año.
              <br data-id="element-113" />
              <span className="text-gold font-bold not-italic" data-id="element-114">
                El segundo mejor momento es hoy.
              </span>
              "
            </div>

            <p className="text-xl font-serif font-bold text-white mb-2" data-id="element-115">
              📚 Mega Pack Química en el Aula
            </p>
            <p className="text-sm text-gray-400 mb-8" data-id="element-116">
              Hecho por especialistas, para docentes de los 15 países
              hispanohablantes de América Latina.
            </p>

            <Button href="#pricing" className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-117">
              🟡 QUIERO MI MEGA PACK AHORA
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-500" data-id="element-118">
              <span className="flex items-center gap-1" data-id="element-119">
                <Check size={12} className="text-success" data-id="element-120" /> Garantía de 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-121">
                <Check size={12} className="text-success" data-id="element-122" /> Pago seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-123">
                <Check size={12} className="text-success" data-id="element-124" /> Acceso inmediato
              </span>
              <span className="flex items-center gap-1" data-id="element-125">
                <Check size={12} className="text-success" data-id="element-126" /> Pagas en tu moneda
                local
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}